import Cookies from 'js-cookie';
import { InputCookie } from '../setCookiesAction';
import { ConsentInput } from '../types';
import { shallowEqualConsent } from '../utils';
export const COOKIE_CONSENT_NAME = 'ao-cookie-consent';
let lastValue: ConsentInput | null = null;
function getCookieValue(): ConsentInput | null {
  if (typeof document === 'undefined') return null;
  try {
    const value = Cookies.get(COOKIE_CONSENT_NAME);
    if (!value) return lastValue;
    const parsed = JSON.parse(value) as ConsentInput;
    if (shallowEqualConsent(parsed, lastValue)) {
      return lastValue;
    }
    lastValue = parsed;
    return parsed;
  } catch {
    return null;
  }
}
export function useConsentCookies({
  setCookies
}: {
  setCookies: (...cookies: InputCookie[]) => Promise<void>;
}) {
  // Initialize from server cookies on first render

  async function setConsent(newConsent: ConsentInput): Promise<void> {
    // Skip update if the consent values are equal
    if (lastValue && shallowEqualConsent(lastValue, newConsent)) {
      return;
    }
    const maxAgeIfAccepted = 365 * 24 * 60 * 60; // 1 year
    const maxAgeIfDeclined = 1 * 24 * 60 * 60; // 1 day
    const maxAge = Object.values(newConsent).every(value => value === 'denied') ? maxAgeIfDeclined : maxAgeIfAccepted;
    const consentUpdated = Object.assign({}, lastValue, newConsent);
    lastValue = consentUpdated;
    await setCookies({
      name: COOKIE_CONSENT_NAME,
      value: JSON.stringify(consentUpdated),
      maxAge
    });
  }
  return {
    setConsent,
    getCookieValue
  };
}